import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
//
import { Typography, makeStyles } from "components/mui";
import Moment from "moment";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    typography: {
      display: "inline-block"
    }
  };
});
var DateFormater = function DateFormater(_ref) {
  var value = _ref.value,
    className = _ref.className,
    format = _ref.format,
    relativeUnit = _ref.relativeUnit,
    _ref$emptyValue = _ref.emptyValue,
    emptyValue = _ref$emptyValue === void 0 ? "—" : _ref$emptyValue,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "paragraph_small" : _ref$variant,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    color = _ref.color,
    dataTestid = _ref.dataTestid,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? null : _ref$prefix,
    renderText = _ref.renderText,
    _ref$parseFormat = _ref.parseFormat,
    parseFormat = _ref$parseFormat === void 0 ? Moment.ISO_8601 : _ref$parseFormat;
  var classes = useStyles();
  if (!value) {
    return /*#__PURE__*/_jsx("span", {
      children: emptyValue
    });
  }
  var momentDate;
  if (Moment.isMoment(value)) {
    momentDate = value;
  } else {
    momentDate = Moment(value, parseFormat);
  }
  var dateFormat = format === "pretty" ? "MMM D, YYYY" : format;
  var formattedDate = emptyValue;
  if (value) {
    if (format === "relative" && relativeUnit === "days") {
      var diffInDays = Moment().diff(momentDate, "days");
      var isToday = momentDate.isSame(Moment(), "d");
      if (isToday) {
        formattedDate = "today";
      } else if (diffInDays <= 1) {
        formattedDate = "yesterday";
      } else {
        formattedDate = "".concat(diffInDays, " days ago");
      }
    } else if (format === "relative") {
      var _context;
      formattedDate = _concatInstanceProperty(_context = "".concat(Moment().diff(momentDate, relativeUnit), " ")).call(_context, relativeUnit, " ago");
    } else {
      formattedDate = momentDate.format(dateFormat);
    }
  }
  return /*#__PURE__*/_jsx("time", {
    className: className,
    dateTime: momentDate.format(),
    style: style,
    children: renderText ? renderText(formattedDate) : /*#__PURE__*/_jsxs(Typography, {
      color: color,
      variant: variant,
      weight: weight,
      component: "span",
      className: classes.typography,
      "data-testid": dataTestid,
      children: [prefix, formattedDate]
    })
  });
};
DateFormater.defaultProps = {
  format: "MM/DD/YYYY"
};
export default DateFormater;